/**
 *
 * @param bagId 00010002
 * @returns 0001 0002
 */
export const formatBagId = (bagId: string) => `${bagId.slice(0, 4)} ${bagId.slice(4)}`;

/**
 *
 * @param bagId 00010002
 * @returns 2
 */
export const getBagPlace = (bagId: string) => Number(bagId.slice(4));

export const isValidBagId = (id: string | null) => {
  return typeof id === 'string' && id.length === 8;
};
